import { combineReducers } from 'redux';
import { ArticleSectionReducer as articleSection } from './ArticleSection';

export default combineReducers({
  articleSection,
});
